

function handleSettingsChange(event) {
    const target = event.target;
    if (!(target instanceof HTMLInputElement)) return;
    const form = target.closest('form');
    if (!form) return;
    const formId = form.getAttribute('id');
    if (!formId) return;
    const row = form.closest('tr');
    if (!row) return;
    const related = row.querySelector(`[form="${formId}"]`);
    if (related && related instanceof HTMLElement) {
        related.style.visibility = 'visible';
    }
}

function handleSettingsSubmit(event) {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    const confirmElement = document.getElementById('confirm-update');
    const prompt = confirmElement ? confirmElement.getAttribute('data-confirm-text') : '';
    const proceed = confirm(prompt || 'are you sure?');
    if (!proceed) {
        event.preventDefault();
        return false;
    }
}
const init = () => {
    // only show "Update" button once a setting has been altered
    const settings = document.querySelector('.settings');
    if (settings) {
        settings.removeEventListener('change', handleSettingsChange, true);
        settings.addEventListener('change', handleSettingsChange, true);
        settings.removeEventListener('submit', handleSettingsSubmit, true);
        settings.addEventListener('submit', handleSettingsSubmit, true);
    }
}

document.addEventListener('turbo:load', init, true);
document.addEventListener('DOMContentLoaded', init, true);
